import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Anemia(props) {
  useEffect(() => {

  })
  return (
    <PageWrapper className={"dis-09-anemia-page"}>
      <>
        {/*?php include 'header.php'; ?*/}
        <div className="pageWrapper">
          <DetailHeader diseaseName={"Anemia"}></DetailHeader>
          <div className="MainContent">
            <div className="container">
              <div className="page-rte">
                <p>
                  Anemia is a <b>condition in which you lack enough healthy red
                    blood cells to carry adequate oxygen to your body's
                    tissues.</b> Having
                  anemia, also referred to as low hemoglobin, can make you feel tired
                  and weak.
                </p>
                <div className="row">
                  <div className="col-12 textCenter">
                    <img src={require("../../img/Disease/Anemia/1.png")} alt="anemia" />
                  </div>
                </div>
               
               <br></br>
                <p>
                  <b>Symptoms</b>
                </p>
                <ul className="listUnstyle">
                  <li>Dizziness</li>
                  <li>Fatigue</li>
                  <li>Light-headedness or malaise</li>
                  <li>fast heart rate or palpitations</li>
                  <li>brittle nails</li>
                  <li>headache</li>
                  <li>pallor</li>
                  <li>shortness of breath</li>
                  <li>weakness</li>
                </ul>
                <a className="links" href="https://en.wikipedia.org/wiki/Anemia">
                  For More Details
                </a>
              </div>
            </div>
          </div>
        </div>
        {/*?php include 'footer.php'; ?*/}
      </>

    </PageWrapper>
  );
}

export default Anemia;